import { Box, Stack, Typography } from '@mui/material'
import Slider from '@mui/material/Slider'
import { useEffect, useRef, useState } from 'react'
import DialogConfirm from './Dialog'

interface Props {
  open: boolean
  imgSrc: string
  handleClose: () => void
  handleSubmit: (width: number) => void
}

export default function FixSize({
  open,
  imgSrc,
  handleClose,
  handleSubmit,
}: Props) {
  const dialogRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState(0)
  const onSubmit = async () => {
    handleSubmit(width)
  }
  useEffect(() => {
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.src = imgSrc
    img.onload = function () {
      setWidth(img.width)
    }
  }, [imgSrc])

  return (
    <DialogConfirm
      open={open}
      handleClose={handleClose}
      handleSubmit={onSubmit}
      maxWidth="md"
      title={'画像プレビュー'}
      primaryButtonColor="secondary"
      primaryButtonText="決定する"
    >
      <Stack ref={dialogRef} className="items-center justify-center">
        <Stack width="100%" py={1} mb={1} px="6%" border="1px solid #eee">
          <Typography>幅の調整</Typography>
          <Slider
            value={width}
            min={100}
            step={1}
            max={
              dialogRef.current && window.innerWidth > 600
                ? dialogRef.current.offsetWidth
                : 1000
            }
            onChange={(event: Event, newValue: number | number[]) => {
              setWidth(newValue as number)
            }}
            valueLabelDisplay="on"
            aria-labelledby="non-linear-slider"
          />
        </Stack>
      </Stack>
      <Stack
        sx={{
          maxHeight: '70vh',
          minHeight: 300,
        }}
        className="justify-center items-center"
      >
        <Box
          component="img"
          width={width}
          maxWidth="100%"
          src={imgSrc}
          loading="lazy"
        ></Box>
      </Stack>
    </DialogConfirm>
  )
}
